import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { Municipality } from './Municipality';

@Injectable()
export class MunicipalityService {
  private clientIdSource = new BehaviorSubject<any>(new Municipality());
  private data: Municipality;
  private map = new Map();
  private prevUrl: string = '/home';
  currentMunicipality = this.clientIdSource.asObservable();
  clientIdForNewUm = new Subject();
  municipalities = [
    {
      name: 'აბაშის მუნიციპალიტეტი',
      flag: 'Abasha.png',
      clientId: 2731,
      code: 'Abasha-city-hall-id',
      disabled: false
    },
    {
      name: 'ადიგენის მუნიციპალიტეტი',
      flag: 'Adigeni.png',
      clientId: 5367,
      code: '',
      disabled: false
    },
    {
      name: 'ამბროლაურის მუნიციპალიტეტი',
      flag: 'Ambrolauri.png',
      clientId: 2755,
      code: '',
      disabled: false
    },
    {
      name: 'ასპინძის მუნიციპალიტეტი',
      flag: 'Aspindza.png',
      clientId: 4294,
      code: '',
      disabled: false
    },
    {
      name: 'ახალქალაქის მუნიციპალიტეტი',
      flag: 'Akhalkalaki.png',
      clientId: 5371,
      code: '',
      disabled: false
    },
    {
      name: 'ახალციხის მუნიციპალიტეტი',
      flag: 'Akhaltsikhe.png',
      clientId: 2740,
      code: 'Akhaltsikhe-city-hall-id',
      disabled: false
    },
    {
      name: 'ახმეტის მუნიციპალიტეტი',
      flag: 'Akhmeta.png',
      clientId: 4096,
      code: '',
      disabled: false
    },
    {
      name: 'თვითმმართველი ქალაქი ბათუმი',
      flag: 'Batumi.png',
      clientId: 2715,
      code: 'batumi-city-hall-id',
      disabled: false
    },
    {
      name: 'ბაღდათის მუნიციპალიტეტი',
      flag: 'Bagdati.png',
      clientId: 4113,
      code: '',
      disabled: false
    },
    {
      name: 'ბოლნისის მუნიციპალიტეტი',
      flag: 'Bolnisi.png',
      clientId: 5361,
      code: '',
      disabled: false
    },
    {
      name: 'ბორჯომის მუნიციპალიტეტი',
      flag: 'Borjomi.png',
      clientId: 2742,
      code: 'Borjomi-city-hall-id',
      disabled: false
    },
    {
      name: 'გარდაბნის მუნიციპალიტეტი',
      flag: 'Gardabani.png',
      clientId: 2752,
      code: 'Gardabani-city-hall-id',
      disabled: false
    },
    {
      name: 'გორის მუნიციპალიტეტი',
      flag: 'Gori.png',
      clientId: 2744,
      code: 'Gori-city-hall-id',
      disabled: false
    },
    {
      name: 'გურჯანიის მუნიციპალიტეტი',
      flag: 'Gurjaani.png',
      clientId: 4092,
      code: '',
      disabled: false
    },
    {
      name: 'დედოფლისწყაროს მუნიციპალიტეტი',
      flag: 'Dedoplistsqaro.png',
      clientId: 4123,
      code: '',
      disabled: false
    },
    {
      name: 'დმანისის მუნიციპალიტეტი',
      flag: 'Dmanisi.png',
      clientId: 5363,
      code: '',
      disabled: false
    },
    {
      name: 'დუშეთის მუნიციპალიტეტი',
      flag: 'Dusheti.png',
      clientId: 5387,
      code: '',
      disabled: false
    },
    {
      name: 'ვანის მუნიციპალიტეტი',
      flag: 'Vani.png',
      clientId: 4115,
      code: '',
      disabled: false
    },
    {
      name: 'ზესტაფონის მუნიციპალიტეტი',
      flag: 'Zestaponi.png',
      clientId: 2738,
      code: 'Zestafoni-city-hall-id  ',
      disabled: false
    },
    {
      name: 'ზუგდიდის მუნიციპალიტეტი',
      flag: 'Zugdidi.png',
      clientId: 2725,
      code: 'zugdidi-city-hall-id',
      disabled: false
    },
    {
      name: 'ქალაქ თბილისის მუნიციპალიტეტი',
      flag: 'Tbilisi.png',
      clientId: 41,
      code: 'tbilisi-city-hall-id',
      disabled: false
    },
    {
      name: 'თეთრიწყაროს მუნიციპალიტეტი',
      flag: 'tetriwyaro.png',
      clientId: 5379,
      code: '',
      disabled: false
    },
    {
      name: 'თელავის მუნიციპალიტეტი',
      flag: 'Telavi.png',
      clientId: 102,
      code: '',
      disabled: false
    },
    {
      name: 'თერჯოლის მუნიციპალიტეტი',
      flag: 'Terjola.png',
      clientId: 2736,
      code: 'Terjola-city-hall-id',
      disabled: false
    },
    {
      name: 'თიანეთის მუნიციპალიტეტი',
      flag: 'Tianeti.png',
      clientId: 5385,
      code: '',
      disabled: false
    },
    {
      name: 'კასპის მუნიციპალიტეტი',
      flag: 'Kaspi.png',
      clientId: 4100,
      code: '',
      disabled: false
    },
    {
      name: 'ლაგოდეხის მუნიციპალიტეტი',
      flag: 'Lagodekhi.png',
      clientId: 4090,
      code: '',
      disabled: false
    },
    {
      name: 'ლანჩხუთის მუნიციპალიტეტი',
      flag: 'Lanchkhuti.png',
      clientId: 2719,
      code: 'lanchkhuti-city-hall-id',
      disabled: false
    },
    {
      name: 'ლენტეხის მუნიციპალიტეტი',
      flag: 'Lentekhi.png',
      clientId: 5351,
      code: '',
      disabled: false
    },
    {
      name: 'მარნეულის მუნიციპალიტეტი',
      flag: 'Marneuli.png',
      clientId: 2750,
      code: 'Marneuli-city-hall-id',
      disabled: false
    },
    {
      name: 'მარტვილის მუნიციპალიტეტი',
      flag: 'Martvili.png',
      clientId: 4121,
      code: '',
      disabled: false
    },
    {
      name: 'მესტიის მუნიციპალიტეტი',
      flag: 'Mestia.png',
      clientId: 5389,
      code: '',
      disabled: false
    },
    {
      name: 'მცხეთის მუნიციპალიტეტი',
      flag: 'Mtskheta.png',
      clientId: 2746,
      code: 'Mtskheta-city-hall-id',
      disabled: false
    },
    {
      name: 'ნინოწმინდის მუნიციპალიტეტი',
      flag: 'Ninotsminda.png',
      clientId: 5377,
      code: '',
      disabled: false
    },
    {
      name: 'ოზურგეთის მუნიციპალიტეტი',
      flag: 'Ozurgeti.png',
      clientId: 2717,
      code: 'ozurgeti-city-hall-id',
      disabled: false
    },
    {
      name: 'ონის მუნიციპალიტეტი',
      flag: 'Oni.png',
      clientId: 4104,
      code: '',
      disabled: false
    },
    {
      name: 'თვითმმართველი ქალაქი რუსთავი',
      flag: 'Rustavi.png',
      clientId: 2748,
      code: 'Rustavi-city-hall-id',
      disabled: false
    },
    {
      name: 'საგარეჯოს მუნიციპალიტეტი',
      flag: 'Sagarejo.png',
      clientId: 4127,
      code: '',
      disabled: false
    },
    {
      name: 'სამტრედიის მუნიციპალიტეტი',
      flag: 'Samtredia.png',
      clientId: 4117,
      code: '',
      disabled: false
    },
    {
      name: 'საჩხერის მუნიციპალიტეტი',
      flag: 'Sachkhere.png',
      clientId: 4110,
      code: '',
      disabled: false
    },
    {
      name: 'სენაკის მუნიციპალიტეტი',
      flag: 'Senaki.png',
      clientId: 2729,
      code: 'Senaki-city-hall-id',
      disabled: false
    },
    {
      name: 'სიღნაღის მუნიციპალიტეტი',
      flag: 'Signagi.png',
      clientId: 4125,
      code: '',
      disabled: false
    },
    {
      name: 'ტყიბულის მუნიციპალიტეტი',
      flag: 'Tkibuli.png',
      clientId: 4105,
      code: '',
      disabled: false
    },
    {
      name: 'თვითმმართველი ქალაქი ფოთი',
      flag: 'Poti.png',
      clientId: 2723,
      code: 'poti-city-hall-id',
      disabled: false
    },
    {
      name: 'ქარელის მუნიციპალიტეტი',
      flag: 'Kareli.png',
      clientId: 5359,
      code: '',
      disabled: false
    },
    {
      name: 'ქედის მუნიციპალიტეტი',
      flag: 'Kedi.png',
      clientId: 5349,
      code: '',
      disabled: false
    },
    {
      name: 'ქობულეთის მუნიციპალიტეტი',
      flag: 'Kobuleti.png',
      clientId: 5369,
      code: '',
      disabled: false
    },
    {
      name: 'თვითმმართველი ქალაქი ქუთაისი',
      flag: 'Kutaisi.png',
      clientId: 110,
      code: 'quteisi',
      disabled: false
    },
    {
      name: 'ყაზბეგის მუნიციპალიტეტი',
      flag: 'Kazbegi.png',
      clientId: 5357,
      code: '',
      disabled: false
    },
    {
      name: 'ყვარლის მუნიციპალიტეტი',
      flag: 'Kvareli.png',
      clientId: 4094,
      code: '',
      disabled: false
    },
    {
      name: 'ყაზბეგის მუნიციპალიტეტი',
      flag: 'Kazbegi.png',
      clientId: 5357,
      code: '',
      disabled: false
    },
    {
      name: 'ყვარლის მუნიციპალიტეტი',
      flag: 'Kvareli.png',
      clientId: 4094,
      code: '',
      disabled: false
    },
    {
      name: 'ჩოხატაურის მუნიციპალიტეტი',
      flag: 'Chokhatauri.png',
      clientId: 2721,
      code: 'chokhatauri-city-hall-id',
      disabled: false
    },
    {
      name: 'ჩხოროწყუს მუნიციპალიტეტი',
      flag: 'Chkhorotsku.png',
      clientId: 5365,
      code: '',
      disabled: false
    },
    {
      name: 'ცაგერის მუნიციპალიტეტი',
      flag: 'Tsageri.png',
      clientId: 4102,
      code: '',
      disabled: false
    },
    {
      name: 'წალენჯიხის მუნიციპალიტეტი',
      flag: 'Tsalenjikha.png',
      clientId: 5381,
      code: '',
      disabled: false
    },
    {
      name: 'წალკის მუნიციპალიტეტი',
      flag: 'Tsalka.png',
      clientId: 5373,
      code: '',
      disabled: false
    },
    {
      name: 'წყალტუბოს მუნიციპალიტეტი',
      flag: 'Tskhaltubo.png',
      clientId: 2734,
      code: 'Tskaltubo-city-hall-id',
      disabled: false
    },
    {
      name: 'ჭიათურის მუნიციპალიტეტი',
      flag: 'Chiatura.png',
      clientId: 4108,
      code: '',
      disabled: false
    },
    {
      name: 'ხარაგაულის მუნიციპალიტეტი',
      flag: 'Kharagauli.png',
      clientId: 4112,
      code: '',
      disabled: false
    },
    {
      name: 'ხაშურის მუნიციპალიტეტი',
      flag: 'Khashuri.png',
      clientId: 4098,
      code: '',
      disabled: false
    },
    {
      name: 'ხელვაჩაურის მუნიციპალიტეტი',
      flag: 'khelvachauri.png',
      clientId: 5383,
      code: '',
      disabled: false
    },
    {
      name: 'ხობის მუნიციპალიტეტი',
      flag: 'Khobi.png',
      clientId: 2727,
      code: 'Khobi-city-hall-id',
      disabled: false
    },
    {
      name: 'ხონის მუნიციპალიტეტი',
      flag: 'Khoni.png',
      clientId: 4119,
      code: '',
      disabled: false
    },
    {
      name: 'ხულოს მუნიციპალიტეტი',
      flag: 'Khulo.png',
      clientId: 5353,
      code: '',
      disabled: false
    }
  ];
  constructor(private injector: Injector) {}

  public changeClient(
    clientId = null,
    forceNavigate?: boolean,
    redirectTo?: string
  ): void {
    if (!clientId) {
      const queryClientId = this._getQueryClientId();
      if (queryClientId && queryClientId !== 'null') {
        const isAdmin = document.location.href.includes('admin');
        if (isAdmin) {
          return this.changeClient(Number(queryClientId));
        } else {
          return this.changeClient(Number(queryClientId), true, '/home');
        }
      }
    }

    const _router = this.injector.get(Router);
    if (_router.url !== '/select-municipality') {
      this.prevUrl = _router.url;
    }

    if (clientId) {
      if (this.map.has(Number(clientId))) {
        localStorage.setItem('clientId', clientId);
        sessionStorage.setItem('clientId', clientId);
        this.clientIdSource.next(this.map.get(clientId));
        if (forceNavigate) {
          _router.navigate([redirectTo || this.prevUrl]);
        }
      } else {
        alert('no client found for this url');
      }
    } else {
      if (sessionStorage.getItem('clientId')) {
        this.changeClient(parseInt(sessionStorage.getItem('clientId'), 10));
      } else {
        if (localStorage.getItem('clientId')) {
          if (_router.url === '/home') {
            sessionStorage.setItem('clientId', clientId);
            this.changeClient(parseInt(localStorage.getItem('clientId'), 10));
          } else {
            _router.navigate(['/select-municipality']);
          }
        } else {
          if (_router.url !== '/select-municipality') {
            _router.navigate(['/select-municipality']);
          }
        }
      }
    }
  }
  changeClientForAdmin(clientId: number, clients?: any) {
    const _router = this.injector.get(Router);
    if (clientId) {
      if (this.map.has(Number(clientId))) {
        localStorage.setItem('clientId', String(clientId));
        sessionStorage.setItem('clientId', String(clientId));
        this.clientIdSource.next(this.map.get(clientId));
      } else {
        alert('no client found for this url');
      }
    } else {
      if (clients && Object.keys(clients).length) {
        this.changeClientForAdmin(Number(Object.keys(clients)[0]));
      }
      if (sessionStorage.getItem('clientId')) {
        this.changeClientForAdmin(parseInt(sessionStorage.getItem('clientId')));
      } else {
        if (localStorage.getItem('clientId')) {
          if (_router.url === '/home') {
            sessionStorage.setItem('clientId', String(clientId));
            this.changeClientForAdmin(
              parseInt(localStorage.getItem('clientId'), 10)
            );
          } else {
            _router.navigate(['/admin/select-municipality']);
          }
        } else {
          if (_router.url !== '/admin/select-municipality') {
            _router.navigate(['/admin/select-municipality']);
          }
        }
      }
    }
  }
  private _getQueryClientId() {
    return new URLSearchParams(window.location.search).get('clientId');
  }

  load() {
    return fetch(environment.jsonURL)
      .then((r) => r.json())
      .then((data) => {
        this.data = data;
        this.fillMap();
      })
      .catch(() => {
        console.error('Could not load configuration');
      });
  }

  private fillMap(): void {
    for (let key in this.data) {
      this.map.set(parseInt(key, 10), this.data[key]);
    }
  }
  public municipalityFlag(clientId: number) {
    if (!clientId) {
      return '';
    }
    const municipality = this.municipalities.find(
      (municipality: any) => municipality.clientId === Number(clientId)
    );
    if (!municipality || !municipality.flag || !municipality.flag.length) {
      return '';
    }
    return municipality.flag;
  }
  municipalityName(clientId: number) {
    if (!clientId) {
      return '';
    }
    const municipality = this.municipalities.find(
      (municipality: any) => municipality.clientId === Number(clientId)
    );
    if (!municipality || !municipality.flag || !municipality.flag.length) {
      return '';
    }
    return municipality.name;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/municipality.service.ts